import React, { useContext, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { login } from "../http/userApi";
import { CONTRACTS_ROUTE } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../index";

const Auth = observer(() => {
  const { user } = useContext(Context);
  const navigate = useNavigate();
  const [nickname, setNickname] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // useEffect(() => {
  //   if (user.isAuth) navigate(MAIN_ROUTE);
  // });

  const onAuth = async () => {
    setError("");
    try {
      const data = await login(nickname, password);
      console.log(data);
      console.log(user);
      user.setUser(data);
      user.setIsAuth(true);
      navigate(CONTRACTS_ROUTE);
      document.location.reload(true);
    } catch (error) {
      console.log(error);
      setError("error");
    }
  };

  return (
    <>
      <div className="login__page">
        <Typography
          variant="h6"
          noWrap
          component="a"
          sx={{
            mr: 2,
            display: { xs: "none", md: "flex" },
            fontFamily: "monospace",
            fontWeight: 700,
            letterSpacing: ".3rem",
            color: "inherit",
            textDecoration: "none",
          }}
        >
          RADIORECORD
        </Typography>
        {error && <p>{error}</p>}
        <div style={{ margin: "20px" }}>
          <TextField
            className="login__page__item"
            label="Login"
            variant="outlined"
            color="secondary"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />
        </div>
        <TextField
          label="Пароль"
          variant="outlined"
          color="secondary"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          style={{ margin: "20px" }}
          variant="contained"
          color="secondary"
          onClick={onAuth}
        >
          Войти
        </Button>
      </div>
    </>
  );
});

export default Auth;
